export const data = [{
  major_budget_category_name: 'hc host',
  children: [{
    id: 2,
    budget_subject_name: '人事服务费',
    detail: [{
        month: '2020-01',
        total_money: 1000, //初始默认预算值

      },
      {
        month: '2020-02',
        frozen_money: 100,
        total_money: 2000,
        changed_money: 1000, //修改后的金额
      },
      {
        month: '2020-03',
        total_money: 3000,
        changed_money: 1000, //修改后的金额
      },
      {
        month: '2020-04',
        total_money: 4000,
        changed_money: 8000, //修改后的金额
      },
      {
        month: '2020-05',
        total_money: 5000,
        changed_money: 8000, //修改后的金额
      },
      {
        month: '2020-06',
        total_money: 6000,
        changed_money: 1000, //修改后的金额
      },
      {
        month: '2020-07',
        total_money: 7000,
      },
      {
        month: '2020-08',
        total_money: 8000,
      },
      {
        month: '2020-09',
        total_money: 9000,
      },
      {
        month: '2020-10',
        total_money: 10000,
      },
      {
        month: '2020-11',
        total_money: 1000,
      },
      {
        month: '2020-12',
        total_money: 10000,
      },
    ],
  }, {
    budget_subject_name: '差旅补助',
    detail: [{
        month: '2020-01',
        total_money: 8000, //初始默认预算值
        // changed_money: 10000, //修改后的金额
      },
      {
        month: '2020-02',
        frozen_money: 100,
        total_money: 7000,
      },
      {
        month: '2020-03',
        total_money: 1000,
      },
      {
        month: '2020-04',
        total_money: 4000,
      },
      {
        month: '2020-05',
        total_money: 7000,
      },
      {
        month: '2020-06',
        total_money: 6000,
      },
      {
        month: '2020-07',
        total_money: 8000,
      },
      {
        month: '2020-08',
        total_money: 8000,
      },
      {
        month: '2020-09',
        total_money: 10000,
      },
      {
        month: '2020-10',
        total_money: 8000,
      },
      {
        month: '2020-11',
        total_money: 10000,
      },
      {
        month: '2020-12',
        total_money: 10000,
      },
    ],
  }],
}, {
  major_budget_category_name: 'op cost',
  children: [{
    id: 2,
    budget_subject_name: '人事服务费',
    detail: [{
        month: '2020-01',
        total_money: 1000, //初始默认预算值
        // changed_money: 10000, //修改后的金额
      },
      {
        month: '2020-02',
        frozen_money: 100,
        total_money: 2000,
      },
      {
        month: '2020-03',
        total_money: 3000,
      },
      {
        month: '2020-04',
        total_money: 4000,
      },
      {
        month: '2020-05',
        total_money: 5000,
      },
      {
        month: '2020-06',
        total_money: 6000,
      },
      {
        month: '2020-07',
        total_money: 7000,
      },
      {
        month: '2020-08',
        total_money: 8000,
      },
      {
        month: '2020-09',
        total_money: 9000,
      },
      {
        month: '2020-10',
        total_money: 10000,
      },
      {
        month: '2020-11',
        total_money: 1000,
      },
      {
        month: '2020-12',
        total_money: 10000,
      },
    ],
  }, {
    budget_subject_name: '差旅补助',
    detail: [{
        month: '2020-01',
        total_money: 8000, //初始默认预算值
        // changed_money: 10000, //修改后的金额
      },
      {
        month: '2020-02',
        frozen_money: 100,
        total_money: 7000,
      },
      {
        month: '2020-03',
        total_money: 1000,
      },
      {
        month: '2020-04',
        total_money: 4000,
      },
      {
        month: '2020-05',
        total_money: 7000,
      },
      {
        month: '2020-06',
        total_money: 6000,
      },
      {
        month: '2020-07',
        total_money: 8000,
      },
      {
        month: '2020-08',
        total_money: 8000,
      },
      {
        month: '2020-09',
        total_money: 10000,
      },
      {
        month: '2020-10',
        total_money: 8000,
      },
      {
        month: '2020-11',
        total_money: 10000,
      },
      {
        month: '2020-12',
        total_money: 10000,
      },
    ],
  }],
}, ];